/* ─── Root ─── */

.root {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.root[data-disabled] {
  opacity: 0.38;
  cursor: not-allowed;
}

/* ─── Label ─── */

.label {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  font-family: var(--font-sans);
  font-weight: 600;
  color: var(--md-on-surface-variant);
}

.root[data-invalid] .label {
  color: var(--md-error);
}

/* ─── Input wrapper ─── */

.inputWrapper {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  height: 3rem;
  padding-inline: var(--space-4);
  border-radius: var(--shape-sm);
  transition: outline-color var(--motion-duration-short3)
      var(--motion-easing-standard),
    background var(--motion-duration-short3) var(--motion-easing-standard);
}

/* Outlined variant */

.outlined {
  border: 1px solid var(--md-outline);
  background: transparent;
  outline: none;
}

.outlined:focus-within {
  border-color: var(--md-primary);
  box-shadow: 0 0 0 1px var(--md-primary);
}

.root[data-invalid] .outlined {
  border-color: var(--md-error);
}

.root[data-invalid] .outlined:focus-within {
  border-color: var(--md-error);
  box-shadow: 0 0 0 1px var(--md-error);
}

/* Filled variant */

.filled {
  border: none;
  background: var(--md-surface-container-highest);
  outline: 2px solid transparent;
}

.filled:focus-within {
  outline-color: var(--md-primary);
  background: var(--md-surface-container);
}

.root[data-invalid] .filled {
  outline-color: var(--md-error);
}

.root[data-invalid] .filled:focus-within {
  outline-color: var(--md-error);
  background: var(--md-surface-container);
}

/* ─── Input ─── */

.input {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  all: unset;
  flex: 1;
  min-width: 0;
  font-family: var(--font-sans);
  color: var(--md-on-surface);
}

.input::placeholder {
  color: var(--md-on-surface-variant);
}

.root[data-disabled] .input {
  cursor: not-allowed;
}

/* ─── Adornments ─── */

.adornment {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  color: var(--md-on-surface-variant);
}

.adornment svg {
  width: 1.25rem;
  height: 1.25rem;
}

/* ─── Description ─── */

.description {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  font-family: var(--font-sans);
  color: var(--md-on-surface-variant);
  margin: 0;
}

/* ─── Error ─── */

.error {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  font-family: var(--font-sans);
  color: var(--md-error);
  margin: 0;
}
